<div class="position-relative">
  <div *ngIf="appliedDiscount"
       class="font-md discount-added discount-sibling-margin"
       [class.justify-content-center]="!isApplyDiscountEnabled">
    <i class="icon-check-bold discount-added-icon me-1"></i>
    {{'orderProcess.payment.promoCodeSection.discountAdded' | translate: { value: appliedDiscount.value } }}
  </div>

  <div *ngIf="isPromoCollapsed && isApplyDiscountEnabled"
       class="font-md discount-sibling-margin"
       (click)="isPromoCollapsed=false">
    <span [translate]="'orderProcess.payment.promoCodeSection.doYouHaveDiscount'">
      Do you have promo code?
    </span>&nbsp;<span class="underline" [translate]="'common.clickHere'">
      Click here
    </span>
  </div>

  <div class="discount-sibling-margin"
       *ngIf="!isPromoCollapsed && isApplyDiscountEnabled"
       [ngBusy]="{busy: busy, message: ('common.pleaseWait' | translate)}">
    <div class="fw-bold font-md mb-1"
         [translate]="'orderProcess.payment.promoCodeSection.header'">
      Add promo code
    </div>

    <div class="d-flex mb-1">
      <input type="text" class="form-control w-100"
             (keydown.enter)="newDiscountCode ? applyPromo(newDiscountCode) : null"
             [placeholder]="'orderProcess.payment.promoCodeSection.placeholder' | translate"
             [(ngModel)]="newDiscountCode"
             (ngModelChange)="errorMsg = ''"/>
      <button class="btn btn-pink font-sm ms-3"
              (click)="applyPromo(newDiscountCode)"
              [translate]="'orderProcess.payment.promoCodeSection.apply'">Apply
      </button>
    </div>

    <div *ngIf="errorMsg" class="mt-1 font-md text-danger">
      {{ errorMsg }}
    </div>
  </div>
</div>
